import "./SpecimenListItem.css";

import { Accession, Specimen, SpecimenProtocolOverride } from "pwapi";

import {
  getProtocolStatuses,
  procedureEnumToLabel,
} from "shared/utils/specimenUtils";

import { useAppSelector } from "app/hooks";
import { useSelectedLab } from "hooks/useSelectedLabStation";
import ActionsMenu, { ActionsMenuType } from "ui/components/actionsMenu";
import SpecimenProtocolTags from "ui/components/SpecimenProtocolTags";

const SpecimenListItem = ({
  specimen,
  specimenIndex,
  handleOnDelete,
  setEditingSpecimen,
  lastSpecimen,
  isCaseAccessioned,
  specimens,
  caseType,
}: {
  specimen: Specimen;
  specimenIndex: number;
  handleOnDelete: Function;
  setEditingSpecimen: Function;
  lastSpecimen?: boolean;
  isCaseAccessioned?: boolean;
  specimens: Specimen[];
  caseType?: Accession.case_type;
}) => {
  const difEnabled = useAppSelector(
    (state) => !!state.sys.features.switches?.difProtocol
  );

  const selectedLab = useSelectedLab();

  const pashReflexEnabled = selectedLab?.settings?.pash_reflex?.active;
  const pasfReflexEnabled = selectedLab?.settings?.pasf_reflex?.active;

  const slowMohsEnabled = useAppSelector(
    (state) => !!state.sys.features.switches?.slowMohsProtocol
  );
  const protocolStatuses = getProtocolStatuses(
    specimen,
    undefined,
    selectedLab.settings,
    caseType
  );
  const protocols = Object.entries(protocolStatuses)
    .filter(
      ([protocol, status]) =>
        status.active &&
        (protocol !== "dif" || difEnabled) &&
        (protocol !== SpecimenProtocolOverride.protocol.PASH_REFLEX ||
          pashReflexEnabled) &&
        (protocol !== SpecimenProtocolOverride.protocol.PASF_REFLEX ||
          pasfReflexEnabled) &&
        (protocol !== SpecimenProtocolOverride.protocol.SLOW_MOHS ||
          slowMohsEnabled)
    )
    .map(([protocol, _]) => protocol) as SpecimenProtocolOverride.protocol[];

  return (
    <div className="Object Object--Specimen">
      <header>
        <h2>{specimen.name}</h2>
        <div>
          {specimen.procedure ? (
            <p>{procedureEnumToLabel(specimen.procedure)}</p>
          ) : (
            <p className="Object--Specimen__missing">Missing Procedure</p>
          )}
          <p>{specimen.site}</p>
          {!specimen.clinical_history &&
            !selectedLab?.settings?.transcription_entry?.active && (
              <p className="Object--Specimen__missing">Missing Clinical</p>
            )}
        </div>
      </header>

      {protocols.length > 0 && (
        <div className="Object--Specimen__protocols">
          <SpecimenProtocolTags
            specimen={{ ...specimen, protocols }}
            specimens={specimens}
          />
        </div>
      )}

      <div className="SpecimenListItem__contextMenu">
        <ActionsMenu
          id={`specimenListItem-${specimen.name || specimen.id}`}
          actions={[
            {
              label: "Edit",
              type: ActionsMenuType.BUTTON,
              onClick: () => {
                setEditingSpecimen({
                  specimen: specimen,
                  index: specimenIndex,
                });
              },
            },
            {
              label: "Delete",
              type: ActionsMenuType.BUTTON,
              onClick: () => {
                handleOnDelete({
                  index: specimenIndex,
                  specimen: specimen,
                });
              },
              disabled: !isCaseAccessioned && !lastSpecimen,
              tooltip:
                !isCaseAccessioned && !lastSpecimen
                  ? "Only the last Specimen can be deleted"
                  : undefined,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default SpecimenListItem;
